/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import '../style.scss';
import MicrosoftDialog from '../MicrosoftDialog';
import ZoomMeeting from '../ZoomMeeting';
import GoogleMeet from '../GoogleMeet';
import ListButton from 'component/ListButton';
import Settings from '../Settings';
import SystemInformation from '../SystemInformation';
import utils from 'util/utils';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { AddIcon, CloseIcon, MinusIcon, WhiteLogo } from 'assets/images';
import { useDispatch, useSelector } from 'react-redux';
import { enableSleepMode } from 'store/modules/settings/actions';
import { reloadNow } from 'store/modules/app/actions';
import { showWarningNotification } from 'store/modules/notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from 'store/modules/notifications/constants';
function ConferenceSetting(props) {
  const [counter, setCounter] = React.useState(0);
  const [selected, setSelected] = React.useState(0);
  const [showSystemInfo, setShowSystemInfo] = React.useState(false);
  const [showMediaSettings, setShowMediaSettings] = React.useState(false);
  const [externalAPIControl, setExternalAPIControl] = React.useState(
    window.remoteAPIControlEnabled
  );
  const {
    firstName,
    lastName,
    device: { name: deviceName }
  } = useSelector((state) => state['features/login'].user);
  const displayName = deviceName || firstName + ' ' + lastName;
  const dispatch = useDispatch();
  useEffect(() => {
    try {
      if (window.isDesktop) {
        window.COM.on('api:status', function (event, data) {
          window.remoteAPIControlEnabled = data.active;
          setExternalAPIControl(window.remoteAPIControlEnabled);
        });
        window.COM.on('api:started', function (event, data) {
          window.remoteAPIControlEnabled = data.active;
          setExternalAPIControl(window.remoteAPIControlEnabled);
        });
        window.COM.on('api:disabled', function (event, data) {
          window.remoteAPIControlEnabled = data.active;
          setExternalAPIControl(window.remoteAPIControlEnabled);
        });
        window.COM.on('api:error', function (event, data) {
          dispatch(
            showWarningNotification(
              {
                descriptionKey: data.error,
                titleKey: 'notify.remoteAPIControlError'
              },
              NOTIFICATION_TIMEOUT_TYPE.MEDIUM
            )
          );
        });
        window.COM.send('api:status');
      }
    } catch (e) {
      console.log(e);
    }
  }, []);
  const handleChange = (event) => {
    setCounter(event.target.value);
  };
  function onJoin() {
    setSelected(0);
    const h = utils.getHours(-1);
    const m = utils.getMinutes(-1);

    dispatch(enableSleepMode(h, m, false, true));
    props.onClose();
  }
  function onSubmit() {
    if (counter > 0) {
      const totalMinutes = counter - 1;

      const h = utils.getHours(totalMinutes);
      const m = utils.getMinutes(totalMinutes);

      dispatch(enableSleepMode(h, m, true, false));
      props.onClose();
    }
  }
  function enableDisableRemoteControl() {
    if (window.isDesktop) {
      try {
        window.COM.send(externalAPIControl ? 'api:disable' : 'api:enable');
      } catch (e) {
        console.error(e);
      }
    }
  }

  return (
    <Box className="padding">
      <Box
        className="listWhiteText"
        sx={{
          fontSize: '22px',
          mb: '14px',
          mr: '14px'
        }}>
        {displayName}
      </Box>
      <CloseIcon
        style={{ position: 'absolute', right: 15, top: 20, cursor: 'pointer' }}
        fill="white"
        onClick={(e) => {
          e.stopPropagation();
          props.onClose();
        }}
      />
      <Box className="listWhiteText">Privacy (Minutes)</Box>
      <Box className="flexCenter">
        <Box sx={{ padding: '12px 5px 12px 0px', flex: 1 }}>
          <FormControl sx={{ width: '100%' }}>
            <Input
              inputProps={{ 'aria-label': 'Without label' }}
              onChange={handleChange}
              placeholder="Select Value"
              className="listInput"
              value={counter}
            />
          </FormControl>
        </Box>
        <Box className="listButton">
          <Box
            onClick={() => setCounter(counter + 30)}
            sx={{
              display: 'flex',
              padding: '2px',
              marginRight: '5px',
              cursor: 'pointer'
            }}>
            <AddIcon fill="white" height={20} width={20} />
          </Box>
          <Box
            onClick={() => {
              // eslint-disable-next-line curly
              if (counter > 30) setCounter(counter - 30);
            }}
            sx={{ display: 'flex', padding: '2px', cursor: 'pointer' }}>
            <MinusIcon fill="white" height={20} width={20} />
          </Box>
        </Box>
        <Box
          className="listButton"
          onClick={() => onSubmit()}
          sx={{ cursor: 'pointer' }}>
          <Box className="listButtonText">Submit</Box>
        </Box>
      </Box>
      <Box className="listBody">
        (Put the video window into sleep mode for a set duration and don’t worry
        you can always wake it again at any time with a simple tap.)
      </Box>
      {/* <Box className="listWhiteText" sx={{ padding: '12px 0px' }}>
        External Calls
      </Box>
      <Box className="listText" sx={{ marginBottom: '12px' }}>
        Leave the always-on mode and join an external video meeting
      </Box>
      <Box className="imageContainer">
        {listData.map((stock, index) => (
          <Box key={index}>
            <CardList
              {...stock}
              key={index}
              onPress={handleClickOpen}
              active={selected == stock.id}
              onClick={() => setSelected(stock.id) || setTitle(stock.title)}
            />
          </Box>
        ))}
      </Box>
      {title === 'Microsoft Teams' ? (
        <MicrosoftDialog open={open} onClick={handleClose} />
      ) : (
        <Box />
      )}
      {title === 'Zoom meeting' && (
        <ZoomMeeting open={open} onClick={handleClose} />
      )}
      {title === 'Google Meet' && (
        <GoogleMeet open={open} onClick={handleClose} />
      )} */}
      <Box className="imageContainer">
        <Box sx={{ display: 'flex', flex: 1 }}>
          <ListButton small onClick={() => dispatch(reloadNow())}>
            Reconnect
          </ListButton>
        </Box>
        <Box sx={{ margin: '0px 16px', display: 'flex', flex: 1 }}>
          <ListButton small onClick={() => setShowMediaSettings(true)}>
            Settings
          </ListButton>
        </Box>
        <Box sx={{ display: 'flex', flex: 1 }}>
          <ListButton small onClick={() => setShowSystemInfo(true)}>
            System Information
          </ListButton>
        </Box>
      </Box>
      <Box sx={{ justifyContent: 'center', display: 'flex' }}>
        {window.isDesktop && (
          <>
            <ListButton gray onClick={() => enableDisableRemoteControl()}>
              {externalAPIControl
                ? 'Disable external API'
                : 'Enable external API'}
            </ListButton>
            <div style={{ width: '10px' }} />
          </>
        )}
      </Box>
      <Box className="imageContainer" sx={{ height: '50%' }} />
      <center>
        <Box sx={{ marginTop: '5px' }}>
          <WhiteLogo height={50} width={150} />
        </Box>
        <Box className="listBody">
          Find out more at videowindow.com <br />{' '}
          {`Version : v${process.env.REACT_APP_VERSION}`}
        </Box>
      </center>
      <Settings
        open={showMediaSettings}
        onClose={() => setShowMediaSettings(false)}
      />
      <SystemInformation
        open={showSystemInfo}
        onClose={() => setShowSystemInfo(false)}
      />
      <MicrosoftDialog
        onJoin={onJoin}
        onClose={() => setSelected(0)}
        open={selected === 1}
      />
      <ZoomMeeting
        onJoin={onJoin}
        onClose={() => setSelected(0)}
        open={selected === 2}
      />
      <GoogleMeet
        onJoin={onJoin}
        onClose={() => setSelected(0)}
        open={selected === 3}
      />
    </Box>
  );
}
export default React.memo(withBoundary(ConferenceSetting));
ConferenceSetting.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
};
